import React, { useState, useEffect, useRef } from 'react';
import { http, getAuthorizationHeader } from '../../config/http';
import { useNavigate } from 'react-router-dom';
import Layouts from '../../layouts/Layouts';
import DetailItem from '../Modal/DetailItem';
import { toast } from 'react-toastify';
import {
  IconSend,
  IconSearch,
  IconTrash,
  IconX,
  IconCalendarTime,
  IconReload,
  IconLoader2,
  IconEye,
  IconRefresh
} from '@tabler/icons-react';
import { DateRange } from 'react-date-range';
import 'react-date-range/dist/styles.css'; 
import 'react-date-range/dist/theme/default.css';
import { DinamicTitle } from '../../utils/DinamicTitle';
import moment from 'moment';
import useKarat from '../features/useKarat';
import useBaki from '../features/useBaki';
import PinBrankas from '../../components/Admin/PinBrankas';

export default function PermohonanPindahBrankas() {
  const navigate = useNavigate();
  const token = localStorage.getItem('token');
  const userRole = localStorage.getItem('role');

  const [brankasItems, setBrankasItems] = useState([]);
  const [loadingItems, setLoadingItems] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [catatanPemohon, setCatatanPemohon] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const scanTimeoutRef = useRef(null);
  
  const [isPinVerified, setIsPinVerified] = useState(
    sessionStorage.getItem('brankasPinVerified') === 'true'
  );

  // Filter Bar States (Kategori, Jenis Kategori, Baki, Karat, Cari Berat, Tanggal)
  const [kategoriList, setKategoriList] = useState([]);
  const [selectedKategori, setSelectedKategori] = useState('');
  const [selectedJenisKategori, setSelectedJenisKategori] = useState('');
  const [selectedBaki, setSelectedBaki] = useState('');
  const [selectedKarat, setSelectedKarat] = useState([]);
  const [filterBerat, setFilterBerat] = useState('');
  const [isOpenJenisKategoriModal, setIsOpenJenisKategoriModal] = useState(false);
  const [searchJenisKategori, setSearchJenisKategori] = useState('');
  const [isOpenKonfirmasiModal, setIsOpenKonfirmasiModal] = useState(false);
  const [isOpenSubmitPin, setIsOpenSubmitPin] = useState(false);
  const [isOpenKaratModal, setIsOpenKaratModal] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const selectionRange = {
    startDate: startDate || new Date(),
    endDate: endDate || new Date(),
    key: 'selection',
  };

  const handleSelectDate = (date) => {
    setStartDate(date.selection.startDate);
    setEndDate(date.selection.endDate);
    setCurrentPage(1);
  };

  const awal = startDate ? moment(startDate).format('DD-MM-YYYY') : '';
  const akhir = endDate ? moment(endDate).format('DD-MM-YYYY') : '';

  // Pagination & Search State
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [lastPage, setLastPage] = useState(1);
  const { karatOption } = useKarat();
  const { bakiOption } = useBaki();

  // Map of selected items across all pages: { [id]: itemObject }
  const [selectedItemsMap, setSelectedItemsMap] = useState({});

  // Delete Modal State
  const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [alasanPenghapusan, setAlasanPenghapusan] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);
  const [isOpenBulkDeleteModal, setIsOpenBulkDeleteModal] = useState(false);

  // Detail Modal State
  const [detailItem, setDetailItem] = useState([]);
  const [openDetail, setOpenDetail] = useState(false);

  function closeModalDetail() {
    setOpenDetail(false);
  }

  function showDetailItem(id) {
    http
      .get(`item/${id}`, { headers: { Authorization: getAuthorizationHeader() } })
      .then((res) => {
        setDetailItem(res.data.data);
        setOpenDetail(true);
      })
      .catch((err) => console.log(err));
  }

  // Fetch Kategori Options
  const fetchKategoriOptions = async () => {
    try {
      const res = await http.get(
        'kategori',
        { headers: { Authorization: getAuthorizationHeader() } }
      );
      if (Array.isArray(res.data)) {
        setKategoriList(res.data);
      } else if (res.data.status && Array.isArray(res.data.data)) {
        setKategoriList(res.data.data);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const fetchTemporaryBrankasItems = async (overrideSearchQuery = null) => {
    if (!isPinVerified) return;
    setLoadingItems(true);
    try {
      let url = `item/brankas?page=${currentPage}&per_page=${perPage}&status_pengiriman=ready`;
      
      const queryToUse = overrideSearchQuery !== null ? overrideSearchQuery : searchQuery;

      if (selectedKategori) url += `&kategori=${selectedKategori}`;
      if (selectedJenisKategori) url += `&jenis_kategori=${selectedJenisKategori}`;
      if (selectedBaki) url += `&no_baki=${encodeURIComponent(selectedBaki)}`;
      if (selectedKarat.length > 0) url += `&karat=${encodeURIComponent(selectedKarat.join(','))}`;
      if (filterBerat) url += `&berat=${encodeURIComponent(filterBerat)}`;
      if (queryToUse) url += `&kode=${encodeURIComponent(queryToUse)}`;
      if (startDate && endDate) {
        url += `&tgl_awal=${awal}&tgl_akhir=${akhir}`;
      }

      const res = await http.get(url, {
        headers: { Authorization: getAuthorizationHeader() }
      });

      if (res.data.status) {
        const paginator = res.data.data;
        const items = paginator.data || [];
        setBrankasItems(items);
        setTotalItems(paginator.total || items.length);
        setLastPage(paginator.last_page || 1);

        // Auto-select behavior for barcode scanning
        if (queryToUse && items.length === 1) {
          const matchedItem = items[0];
          setSelectedItemsMap(prev => {
            if (prev[matchedItem.id]) {
              toast.info(`${matchedItem.kode_item} sudah dipilih sebelumnya`, { autoClose: 1500 });
              return prev;
            }
            const newMap = { ...prev };
            newMap[matchedItem.id] = matchedItem;
            toast.success(`${matchedItem.kode_item} berhasil dipilih ✓`, { autoClose: 1500 });
            return newMap;
          });
          setSearchQuery('');
        } else if (queryToUse && items.length === 0) {
          toast.error(`Item dengan kode "${queryToUse}" tidak ditemukan`, { autoClose: 2000 });
        }
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingItems(false);
    }
  };

  useEffect(() => {
    fetchKategoriOptions();
  }, []);

  useEffect(() => {
    fetchTemporaryBrankasItems();
  }, [currentPage, perPage, selectedKategori, selectedJenisKategori, selectedBaki, selectedKarat, startDate, endDate, isPinVerified]);

  // Trigger scan search automatically when input reaches barcode length (e.g. from scanner or copy-paste)
  useEffect(() => {
    if (searchQuery.length >= 10) {
      if (scanTimeoutRef.current) clearTimeout(scanTimeoutRef.current);
      scanTimeoutRef.current = setTimeout(() => {
        setCurrentPage(1);
        fetchTemporaryBrankasItems(searchQuery);
      }, 300);
    }
    return () => {
      if (scanTimeoutRef.current) clearTimeout(scanTimeoutRef.current);
    };
  }, [searchQuery]);

  const handleResetFilters = () => {
    setSelectedKategori('');
    setSelectedJenisKategori('');
    setSelectedBaki('');
    setSelectedKarat([]);
    setFilterBerat('');
    setSearchQuery('');
    setStartDate(null);
    setEndDate(null);
    setCurrentPage(1);
  };

  const handleToggleSelectItem = (item) => {
    const newMap = { ...selectedItemsMap };
    if (newMap[item.id]) {
      delete newMap[item.id];
    } else {
      newMap[item.id] = item;
    }
    setSelectedItemsMap(newMap);
  };

  const handleSelectAllOnPage = () => {
    const pageItemIds = brankasItems.map((i) => i.id);
    const allPageSelected = pageItemIds.every((id) => !!selectedItemsMap[id]);

    const newMap = { ...selectedItemsMap };
    if (allPageSelected) {
      pageItemIds.forEach((id) => delete newMap[id]);
    } else {
      brankasItems.forEach((item) => {
        newMap[item.id] = item;
      });
    }
    setSelectedItemsMap(newMap);
  };

  const selectedItemsList = Object.values(selectedItemsMap);
  const selectedItemIds = Object.keys(selectedItemsMap).map(Number);
  const totalPcs = selectedItemsList.length;
  const totalBerat = selectedItemsList.reduce((acc, i) => acc + parseFloat(i.berat || 0), 0);

  const breakdownCategory = selectedItemsList.reduce((acc, item) => {
    const catName = item.jenis_kategori?.kategori?.nama_kategori || 'Tanpa Kategori';
    const karat = item.karat || '-';
    const berat = parseFloat(item.berat || 0);

    if (!acc[catName]) acc[catName] = { name: catName, pcs: 0, berat: 0, byKarat: {} };
    acc[catName].pcs += 1;
    acc[catName].berat += berat;

    if (!acc[catName].byKarat[karat]) acc[catName].byKarat[karat] = { pcs: 0, berat: 0 };
    acc[catName].byKarat[karat].pcs += 1;
    acc[catName].byKarat[karat].berat += berat;

    return acc;
  }, {});

  const handleKaratFilterClick = (kategoriName, karat) => {
    // Siapkan trigger untuk detail item data karatnya
    // Bisa untuk memfilter tabel atau membuka modal detail items
    console.log(`Trigger dipanggil untuk: Kategori ${kategoriName}, Karat ${karat}`);
    toast.info(`Detail item: ${kategoriName} - ${karat} Karat (Dalam pengembangan)`);
  };

  const handleResetForm = () => {
    setSelectedItemsMap({});
    setCatatanPemohon('');
    toast.success('Form pengajuan berhasil di-reset!');
  };

  // Pre-Submit Request Permohonan (Show Modal)
  const handlePreSubmit = (e) => {
    e.preventDefault();
    if (selectedItemIds.length === 0) {
      toast.warning('Pilih minimal 1 barang dari Brankas Toko untuk diajukan ke Brankas Pusat!');
      return;
    }
    setIsOpenKonfirmasiModal(true);
  };

  // Submit Request Permohonan
  const handleSubmitPermohonan = async () => {
    setIsOpenKonfirmasiModal(false);
    setIsSubmitting(true);
    try {
      const payload = {
        items: selectedItemIds,
        catatan_pemohon: catatanPemohon
      };

      const res = await http.post(
        'permohonan-brankas',
        payload,
        { headers: { Authorization: getAuthorizationHeader() } }
      );

      if (res.data.status) {
        toast.success(res.data.message);
        setSelectedItemsMap({});
        setCatatanPemohon('');
        fetchTemporaryBrankasItems();
        navigate('/histori-permohonan-brankas');
      }
    } catch (err) {
      console.error(err);
      toast.error(err.response?.data?.message || 'Gagal mengajukan permohonan pindah brankas');
    } finally {
      setIsSubmitting(false);
    }
  };

  // Open Hapus Item Modal
  const handleOpenDeleteModal = async (item) => {
    setItemToDelete(item);
    setAlasanPenghapusan('');
    setIsOpenDeleteModal(true);
  };

  const handleOpenBulkDeleteModal = async () => {
    setAlasanPenghapusan('');
    setIsOpenBulkDeleteModal(true);
  };

  const handleSubmitBulkDelete = async (e) => {
    e.preventDefault();
    if (selectedItemIds.length === 0) return;
    if (!alasanPenghapusan.trim()) {
      toast.warning('Silakan tuliskan alasan penghapusan / perbaikan data!');
      return;
    }

    setIsDeleting(true);
    try {
      const res = await http.post(
        '/item-deletions/hapus-langsung',
        {
          items: selectedItemIds,
          tipe_penghapusan: 'brankas_pusat',
          alasan: alasanPenghapusan,
        },
        { headers: { Authorization: getAuthorizationHeader() } }
      );

      if (res.data.status) {
        toast.success(res.data.message || 'Barang berhasil dihapus');
        setIsOpenBulkDeleteModal(false);
        const newMap = { ...selectedItemsMap };
        selectedItemIds.forEach(id => delete newMap[id]);
        setSelectedItemsMap(newMap);
        fetchTemporaryBrankasItems();
      }
    } catch (err) {
      toast.error(err.response?.data?.message || 'Gagal menghapus data.');
    } finally {
      setIsDeleting(false);
    }
  };

  const handleSubmitDeleteItem = async (e) => {
    e.preventDefault();
    if (!itemToDelete) return;
    if (!alasanPenghapusan.trim()) {
      toast.warning('Silakan tuliskan alasan penghapusan / perbaikan data!');
      return;
    }

    setIsDeleting(true);
    try {
      const res = await http.post(
        `permohonan-brankas/delete-item/${itemToDelete.id}`,
        { alasan_penghapusan: alasanPenghapusan },
        { headers: { Authorization: getAuthorizationHeader() } }
      );

      if (res.data.status) {
        toast.success(res.data.message);
        setIsOpenDeleteModal(false);
        const newMap = { ...selectedItemsMap };
        delete newMap[itemToDelete.id];
        setSelectedItemsMap(newMap);
        fetchTemporaryBrankasItems();
      }
    } catch (err) {
      console.error(err);
      toast.error(err.response?.data?.message || 'Gagal menghapus item');
    } finally {
      setIsDeleting(false);
    }
  };

  const handleSelectKarat = (val) => {
    if (selectedKarat.includes(val)) {
        setSelectedKarat(selectedKarat.filter(item => item !== val));
    } else {
        setSelectedKarat([...selectedKarat, val]);
    }
    setCurrentPage(1);
  };

  return (
    <Layouts title="Permohonan Pindah Brankas Toko ke Pusat">
      {!isPinVerified && (
        <PinBrankas 
          onSuccess={() => {
            sessionStorage.setItem('brankasPinVerified', 'true');
            setIsPinVerified(true);
          }} 
        />
      )}
      <div className="w-full p-4 sm:p-6 space-y-6 min-h-[75vh]">

        {/* Form & Table */}
        <form onSubmit={handleSubmitPermohonan} className="grid grid-cols-1 lg:grid-cols-12 gap-6">

          {/* Left Column: Summary Card (3 Cols) */}
          <div className="lg:col-span-3 space-y-5">
            <div className="bg-white dark:bg-slate-800 rounded-md border border-slate-200 dark:border-slate-700 p-5 shadow-sm space-y-4 sticky top-6">
              <h2 className="text-sm font-bold uppercase tracking-wider text-slate-700 dark:text-slate-200 border-b border-slate-100 dark:border-slate-700 pb-3 flex items-center gap-2">
                <IconSend size={18} className="text-amber-500" />
                <span>Ringkasan Pengajuan</span>
              </h2>

              <div className="grid grid-cols-2 gap-3 mb-4">
                <div className="bg-white dark:bg-slate-800 p-3 rounded-md border border-sky-100 dark:border-slate-700">
                  <span className="text-[11px] text-slate-500 block">Total Item:</span>
                  <span className="text-lg font-extrabold text-slate-800 dark:text-slate-100">{totalPcs} <span className="text-xs font-normal">Pcs</span></span>
                </div>
                <div className="bg-white dark:bg-slate-800 p-3 rounded-md border border-sky-100 dark:border-slate-700">
                  <span className="text-[11px] text-slate-500 block">Total Berat:</span>
                  <span className="text-lg font-extrabold text-sky-600 dark:text-sky-400">{totalBerat.toFixed(3)} <span className="text-xs font-normal">gr</span></span>
                </div>
              </div>

              {/* Breakdown Category Summary */}
              {Object.keys(breakdownCategory).length > 0 && (
                <div className="space-y-1.5 pt-3 mb-4 border-t border-sky-200/60 dark:border-slate-700">
                  <span className="text-[11px] font-semibold text-slate-600 dark:text-slate-300 block">Rincian per Kategori:</span>
                  {Object.values(breakdownCategory).map((b, i) => (
                    <div key={i} className="flex justify-between items-center text-xs bg-white/70 dark:bg-slate-800/70 px-2.5 py-1.5 rounded-md border border-sky-100 dark:border-slate-700">
                      <span className="font-medium text-slate-700 dark:text-slate-300">{b.name}</span>
                      <span className="font-bold text-slate-900 dark:text-white">{b.pcs} pcs ({b.berat.toFixed(3)} gr)</span>
                    </div>
                  ))}
                  
                  <button
                    type="button"
                    onClick={() => setIsOpenKaratModal(true)}
                    className="w-full mt-3 py-2 text-[11px] font-bold text-amber-600 dark:text-amber-400 bg-amber-50 dark:bg-amber-900/30 hover:bg-amber-100 dark:hover:bg-amber-900/50 border border-amber-200 dark:border-amber-800 rounded-md transition-all flex items-center justify-center gap-1.5"
                  >
                    <IconEye size={14} /> Lihat Detail Karat
                  </button>
                </div>
              )}

              <div>
                <label className="block text-xs font-bold text-slate-600 dark:text-slate-400 mb-1.5">
                  Catatan Permohonan (Opsional)
                </label>
                <textarea
                  rows={3}
                  placeholder="Catatan tambahan untuk Admin Pusat..."
                  value={catatanPemohon}
                  onChange={(e) => setCatatanPemohon(e.target.value)}
                  className="w-full p-2.5 text-xs border border-slate-300 dark:border-slate-600 rounded-md bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-100 outline-none focus:ring-2 focus:ring-amber-500"
                />
              </div>

              <div className="space-y-2 pt-2">
                <button
                  type="button"
                  onClick={handleResetForm}
                  disabled={selectedItemIds.length === 0 && catatanPemohon === ''}
                  className={`w-full py-2.5 px-4 rounded-md font-bold text-xs transition-all flex items-center justify-center gap-2 ${
                    selectedItemIds.length === 0 && catatanPemohon === ''
                      ? 'bg-slate-100 dark:bg-slate-700/50 text-slate-400 cursor-not-allowed'
                      : 'bg-rose-50 dark:bg-rose-900/20 hover:bg-rose-100 dark:hover:bg-rose-900/40 text-rose-600 dark:text-rose-400 border border-rose-200 dark:border-rose-800/50'
                  }`}
                >
                  <IconRefresh size={16} />
                  <span>Muat Ulang Form Pengajuan</span>
                </button>

                <button
                  type="button"
                  onClick={handlePreSubmit}
                  disabled={selectedItemIds.length === 0 || isSubmitting}
                  className={`w-full py-3.5 px-4 rounded-md font-bold text-sm shadow-lg transition-all flex items-center justify-center gap-2 ${
                    selectedItemIds.length === 0 || isSubmitting
                      ? 'bg-slate-300 dark:bg-slate-700 text-slate-500 cursor-not-allowed'
                      : 'bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 text-white shadow-amber-500/25'
                  }`}
                >
                  <IconSend size={20} />
                  <span>{isSubmitting ? 'Memproses...' : 'Ajukan Permohonan Pindah Brankas'}</span>
                </button>
              </div>
            </div>
          </div>

      {/* MODAL: Detail Karat */}
      {isOpenKaratModal && (
        <div 
          className="fixed inset-0 z-[999] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4"
          onClick={() => setIsOpenKaratModal(false)}
        >
          <div 
            className="bg-amber-50 dark:bg-slate-800 w-full max-w-lg rounded-md p-6 shadow-2xl space-y-5 border border-amber-200 dark:border-slate-700 max-h-[85vh] overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex justify-between items-center border-b border-amber-200/50 dark:border-slate-700 pb-3">
              <h3 className="text-sm font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider">
                Ringkasan Item Berdasarkan Kategori & Karat
              </h3>
              <button 
                onClick={() => setIsOpenKaratModal(false)}
                className="text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 transition-colors"
              >
                <IconX size={20} />
              </button>
            </div>

            <div className="space-y-3">
              {Object.values(breakdownCategory).map((cat, idx) => (
                <div key={idx} className="bg-white dark:bg-slate-900 p-4 rounded-md border border-amber-200/50 dark:border-slate-700 shadow-sm">
                  <div className="flex justify-between items-center mb-3 pb-2 border-b border-slate-100 dark:border-slate-700">
                    <span className="font-bold text-slate-800 dark:text-slate-100 text-[15px]">{cat.name}</span>
                    <span className="font-bold text-amber-700 dark:text-amber-400 text-xs bg-amber-100 dark:bg-amber-900/30 px-2.5 py-1 rounded-md">
                      {cat.pcs} Pcs ({cat.berat.toFixed(3)}g)
                    </span>
                  </div>
                  <div className="flex flex-wrap gap-2.5">
                    {Object.entries(cat.byKarat).map(([karat, val], i) => (
                      <button
                        key={i}
                        type="button"
                        onClick={() => {
                          handleKaratFilterClick(cat.name, karat);
                          setIsOpenKaratModal(false);
                        }}
                        className="flex items-center justify-between gap-4 bg-slate-50 dark:bg-slate-800 hover:bg-amber-50 dark:hover:bg-amber-900/20 px-3.5 py-2 rounded-md text-xs transition-colors border border-slate-200 dark:border-slate-700 hover:border-amber-300 dark:hover:border-amber-700"
                        title={`Klik untuk melihat detail item ${karat} Karat`}
                      >
                        <span className="font-medium text-slate-600 dark:text-slate-400">{karat} Karat</span>
                        <span className="font-bold text-slate-800 dark:text-slate-200">{val.pcs} Pcs / {val.berat.toFixed(3)}g</span>
                      </button>
                    ))}
                  </div>
                </div>
              ))}
            </div>

            <div className="pt-4 border-t border-amber-200/50 dark:border-slate-700 text-right">
              <button
                onClick={() => setIsOpenKaratModal(false)}
                className="px-5 py-2 text-sm font-semibold text-slate-600 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-700 rounded-md transition-all border border-slate-200 dark:border-slate-600"
              >
                Tutup
              </button>
            </div>
          </div>
        </div>
      )}

          {/* Right Column: Temporary Store Brankas Table (9 Cols) */}
          <div className="lg:col-span-9 bg-white dark:bg-slate-800 rounded-md border border-slate-200 dark:border-slate-700 p-5 shadow-sm flex flex-col space-y-4">
            {/* Filter Bar (Matching Image: Kategori, Baki, Karat, Cari Berat + Search) */}
            <div className="flex flex-wrap items-center gap-2 bg-slate-50/70 dark:bg-slate-700/30 p-3 rounded-md border border-slate-200/70 dark:border-slate-700">
              {/* Kategori Select */}
              <select
                value={selectedKategori}
                onChange={(e) => { setSelectedKategori(e.target.value); setSelectedJenisKategori(''); setCurrentPage(1); }}
                className="border border-slate-300 dark:border-slate-600 rounded-md px-3 py-1.5 text-xs text-slate-700 dark:text-slate-200 bg-white dark:bg-slate-700 cursor-pointer outline-none focus:ring-2 focus:ring-amber-500"
              >
                <option value="">Kategori</option>
                {kategoriList.map((kt) => (
                  <option key={kt.id} value={kt.id}>{kt.nama_kategori}</option>
                ))}
              </select>

              {/* Jenis Kategori Modal Trigger */}
              {selectedKategori && (
                <button
                  type="button"
                  onClick={() => setIsOpenJenisKategoriModal(true)}
                  className="px-3 py-1.5 border border-slate-300 dark:border-slate-600 rounded-md bg-white dark:bg-slate-700 text-slate-700 dark:text-slate-200 cursor-pointer hover:border-amber-400 hover:text-amber-500 transition-all duration-200 text-xs flex items-center gap-2 outline-none focus:ring-2 focus:ring-amber-500"
                >
                  {selectedJenisKategori 
                    ? (kategoriList.find(k => k.id === parseInt(selectedKategori))?.jenis_kategori?.find(j => j.id.toString() === selectedJenisKategori)?.nama_jenis || 'Jenis Kategori') 
                    : 'Pilih Jenis Kategori'}
                </button>
              )}

              {/* Baki Select */}
              <select
                value={selectedBaki}
                onChange={(e) => { setSelectedBaki(e.target.value); setCurrentPage(1); }}
                className="border border-slate-300 dark:border-slate-600 rounded-md px-3 py-1.5 text-xs text-slate-700 dark:text-slate-200 bg-white dark:bg-slate-700 cursor-pointer outline-none focus:ring-2 focus:ring-amber-500"
              >
                <option value="">Baki</option>
                {bakiOption.map((bakiNum) => (
                  <option key={bakiNum} value={bakiNum}>Baki {bakiNum}</option>
                ))}
              </select>

              {/* Karat Checkbox Dropdown */}
              <div className="dropdown dropdown-bottom">
                <div
                  tabIndex={0}
                  className="px-3 py-1.5 border border-slate-300 dark:border-slate-600 rounded-md bg-white dark:bg-slate-700 text-slate-700 dark:text-slate-200 cursor-pointer hover:border-amber-400 hover:text-amber-500 transition-all duration-200 flex items-center gap-2 text-xs"
                >
                  <span>
                    {selectedKarat.length > 0 ? `Karat (${selectedKarat.length})` : 'Karat'}
                  </span>
                </div>
                <div tabIndex={0} className="dropdown-content p-2 shadow-xl bg-white dark:bg-slate-800 rounded-md border border-slate-100 dark:border-slate-700 z-50 mt-1 w-52 grid grid-cols-2 gap-1 max-h-60 overflow-y-auto pr-1">
                  {karatOption.map((k) => (
                      <label key={k} className="flex items-center gap-2 cursor-pointer p-1.5 hover:bg-slate-50 dark:hover:bg-slate-700/50 rounded-md transition-colors">
                        <input
                          type="checkbox"
                          className="checkbox checkbox-xs checkbox-warning rounded"
                          checked={selectedKarat.includes(k.toString()) || selectedKarat.includes(k)}
                          onChange={() => handleSelectKarat(k.toString())}
                        />
                        <span className="text-xs font-semibold text-slate-700 dark:text-slate-300">{k}k</span>
                      </label>
                  ))}
                </div>
              </div>

              {/* Date Range Dropdown */}
              <div className="dropdown dropdown-bottom">
                <div
                  tabIndex={0}
                  className="px-3 py-1.5 border border-slate-300 dark:border-slate-600 rounded-md bg-white dark:bg-slate-700 text-slate-700 dark:text-slate-200 cursor-pointer hover:border-amber-400 hover:text-amber-500 transition-all duration-200 flex items-center gap-2 text-xs"
                >
                  <IconCalendarTime size={16} />
                  <span>
                    {startDate && endDate ? (awal === akhir ? awal : `${awal} - ${akhir}`) : 'Semua Tanggal'}
                  </span>
                </div>
                <div tabIndex={0} className="dropdown-content menu p-2 shadow-xl bg-white dark:bg-slate-800 rounded-md border border-slate-100 dark:border-slate-700 z-50 mt-1 right-0 sm:right-auto">
                  <DateRange ranges={[selectionRange]} onChange={handleSelectDate} />
                </div>
              </div>

              {/* Cari Berat Input + Search Button */}
              <div className="flex items-center gap-1.5 flex-1 min-w-[140px]">
                <input
                  type="text"
                  placeholder="Cari Berat"
                  value={filterBerat}
                  onChange={(e) => setFilterBerat(e.target.value)}
                  onKeyDown={(e) => { 
                    if (e.key === 'Enter') { 
                      e.preventDefault(); 
                      setCurrentPage(1); 
                      fetchTemporaryBrankasItems(); 
                    } 
                  }}
                  className="w-full px-3 py-1.5 text-xs border border-slate-300 dark:border-slate-600 rounded-md bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-100 outline-none focus:ring-2 focus:ring-amber-500"
                />
                <button
                  type="button"
                  onClick={() => { setCurrentPage(1); fetchTemporaryBrankasItems(); }}
                  className="px-3 py-1.5 bg-amber-500 hover:bg-amber-600 text-white rounded-md shadow-md transition-all flex items-center justify-center flex-shrink-0"
                  title="Cari"
                >
                  <IconSearch size={16} />
                </button>
              </div>

              {/* Quick Search Kode */}
              <div className="relative flex-1 min-w-[140px]">
                <input
                  type="text"
                  placeholder="Scan Cari barang..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      e.preventDefault();
                      // Only trigger manually if length < 10. If >= 10, the useEffect will auto-trigger it.
                      if (e.target.value.length < 10) {
                        setCurrentPage(1);
                        fetchTemporaryBrankasItems(e.target.value);
                      }
                    }
                  }}
                  className="w-full px-3 py-1.5 text-xs border border-slate-300 dark:border-slate-600 rounded-md bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-100 outline-none focus:ring-2 focus:ring-amber-500"
                />
              </div>

              {/* Reset Filter Button */}
              {(selectedKategori || selectedJenisKategori || selectedBaki || selectedKarat.length > 0 || filterBerat || searchQuery || startDate || endDate) && (
                <button
                  type="button"
                  onClick={handleResetFilters}
                  className="px-2.5 py-1.5 text-xs font-semibold text-rose-600 dark:text-rose-400 hover:bg-rose-50 dark:hover:bg-rose-900/30 rounded-md transition-all"
                >
                  Reload Filter
                </button>
              )}
              
              {/* Toolbar Delete Bulk */}
              {selectedItemIds.length > 0 && (
                <button
                  type="button"
                  onClick={handleOpenBulkDeleteModal}
                  className="px-2.5 py-1.5 bg-rose-500 hover:bg-rose-600 text-white rounded-md text-xs transition-all flex items-center justify-center gap-1 shadow-sm"
                  title="Hapus Barang Terpilih"
                >
                  <IconTrash size={16} />
                  <span>Hapus ({selectedItemIds.length})</span>
                </button>
              )}
              
              <button
                type="button"
                onClick={() => window.location.reload()}
                className="px-2.5 py-1.5 bg-slate-100 hover:bg-slate-200 dark:bg-slate-700/50 dark:hover:bg-slate-600 rounded-md text-slate-500 dark:text-slate-300 transition-all flex items-center justify-center"
                title="Reload Halaman"
              >
                <IconReload size={16} />
              </button>
            </div>

            {/* Table */}
            <div className="flex-1 overflow-x-auto min-h-[380px]">
              {loadingItems ? (
                <div className="py-16 flex flex-col items-center justify-center gap-3 text-slate-400 text-xs font-medium">
                  <IconLoader2 className="animate-spin text-amber-500" size={28} />
                  <span>Memuat data brankas toko...</span>
                </div>
              ) : totalItems === 0 ? (
                <div className="py-16 text-center text-slate-400 text-xs">Tidak ada data barang di brankas toko sementara.</div>
              ) : (
                <table className="w-full text-xs text-left text-slate-600 dark:text-slate-300">
                  <thead className="text-[11px] uppercase border-b border-amber-200/70 dark:border-slate-700">
                    <tr className="bg-gradient-to-r from-amber-50 via-amber-100/80 to-amber-50 dark:from-amber-900/30 dark:via-amber-800/20 dark:to-amber-900/30 text-amber-800 dark:text-amber-300 font-bold tracking-wider">
                      <th className="p-3 w-10 text-center font-bold">No</th>
                      <th className="p-3 font-bold">Kode Barang</th>
                      <th className="p-3 font-bold">Nama Barang</th>
                      <th className="p-3 font-bold">BAKI</th>
                      <th className="p-3 text-center font-bold">Berat | Karat</th>
                      <th className="p-3 font-bold">Tanggal</th>
                      <th className="p-3 text-center font-bold">Aksi</th>
                      <th className="p-3 w-10 text-center">
                        <input
                          type="checkbox"
                          className="checkbox checkbox-xs checkbox-warning rounded border-amber-400"
                          checked={brankasItems.length > 0 && brankasItems.every(i => !!selectedItemsMap[i.id])}
                          onChange={handleSelectAllOnPage}
                        />
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-slate-100 dark:divide-slate-700/50">
                    {brankasItems.map((item, index) => {
                      const isSelected = !!selectedItemsMap[item.id];
                      return (
                        <tr
                          key={item.id}
                          onClick={() => showDetailItem(item.id)}
                          className={`cursor-pointer transition-colors ${
                            isSelected ? 'bg-amber-50/80 dark:bg-amber-900/20' : 'hover:bg-slate-50 dark:hover:bg-slate-700/30'
                          }`}
                        >
                          <td className="p-2 text-center text-slate-500 font-medium">
                            {(currentPage - 1) * perPage + index + 1}.
                          </td>
                          <td className="p-2 font-mono font-bold text-slate-800 dark:text-slate-100">{item.kode_item}</td>
                          <td className="p-2">
                            <span className="font-semibold text-slate-700 dark:text-slate-200">{item.jenis_kategori?.nama_jenis}</span>
                          </td>
                          <td className="p-2 font-mono font-bold text-slate-800 dark:text-slate-100">{item.nomor_rak}</td>
                          <td className="p-2 text-center font-bold text-slate-800 dark:text-slate-100">
                            {parseFloat(item.berat).toFixed(3)} gr | <span className="text-amber-600">{item.karat} K</span>
                          </td>
                          <td className="p-2 text-xs text-slate-500 font-medium">{item.created_at}</td>
                          <td className="p-2 text-center" onClick={(e) => e.stopPropagation()}>
                            <button
                              type="button"
                              disabled={selectedItemIds.length > 1}
                              onClick={() => {
                                if (selectedItemIds.length > 1) return;
                                handleOpenDeleteModal(item);
                              }}
                              className={`p-1.5 rounded-md transition-all ${
                                selectedItemIds.length > 1
                                  ? 'text-slate-300 dark:text-slate-600 cursor-not-allowed'
                                  : 'text-rose-500 hover:bg-rose-50 dark:hover:bg-rose-900/30 cursor-pointer'
                              }`}
                              title={
                                selectedItemIds.length > 1
                                  ? 'Pilih tombol Hapus di atas jika memilih lebih dari 1 item'
                                  : 'Hapus Salah Input (Tercatat di Histori)'
                              }
                            >
                              <IconTrash size={16} />
                            </button>
                          </td>
                          <td className="p-2 text-center" onClick={(e) => e.stopPropagation()}>
                            <input
                              type="checkbox"
                              className="checkbox checkbox-xs checkbox-warning rounded"
                              checked={isSelected}
                              onChange={() => handleToggleSelectItem(item)}
                            />
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                  <tfoot className="bg-amber-50/60 dark:bg-slate-800/80 border-t border-amber-200/60 dark:border-slate-700">
                    <tr>
                      <td colSpan="4" className="p-3 text-right font-bold text-amber-900 dark:text-amber-200">Total Berat Halaman Ini:</td>
                      <td className="p-3 text-center font-bold text-amber-600 dark:text-amber-400">
                        {brankasItems.reduce((sum, item) => sum + parseFloat(item.berat || 0), 0).toFixed(3)} gr
                      </td>
                      <td colSpan="3"></td>
                    </tr>
                  </tfoot>
                </table>
              )}
            </div>

            {/* Server-Side Pagination Controls */}
            {totalItems > 0 && (
              <div className="flex flex-col sm:flex-row items-center justify-between gap-3 pt-3 border-t border-slate-100 dark:border-slate-700 text-xs">
                <div className="flex items-center gap-2 text-slate-500">
                  <span>Tampilkan</span>
                  <select
                    value={perPage}
                    onChange={(e) => {
                      setPerPage(Number(e.target.value));
                      setCurrentPage(1);
                    }}
                    className="px-2 py-1 border border-slate-300 dark:border-slate-600 rounded-md bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-100 outline-none focus:ring-1 focus:ring-amber-500"
                  >
                    <option value={10}>10</option>
                    <option value={25}>25</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                  </select>
                  <span>data per halaman</span>
                </div>

                <div className="text-slate-500 font-medium">
                  Halaman {currentPage} dari {lastPage} (Total {totalItems} data brankas)
                </div>

                {lastPage > 1 && (
                  <div className="flex items-center gap-1">
                    <button
                      type="button"
                      disabled={currentPage === 1}
                      onClick={() => setCurrentPage(currentPage - 1)}
                      className="px-2.5 py-1 rounded-md border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-700 text-slate-700 dark:text-slate-200 disabled:opacity-40 disabled:cursor-not-allowed hover:bg-slate-50 dark:hover:bg-slate-600 transition-all"
                    >
                      Prev
                    </button>
                    <span className="px-3 py-1 font-bold text-amber-600 dark:text-amber-400">
                      {currentPage} / {lastPage}
                    </span>
                    <button
                      type="button"
                      disabled={currentPage === lastPage}
                      onClick={() => setCurrentPage(currentPage + 1)}
                      className="px-2.5 py-1 rounded-md border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-700 text-slate-700 dark:text-slate-200 disabled:opacity-40 disabled:cursor-not-allowed hover:bg-slate-50 dark:hover:bg-slate-600 transition-all"
                    >
                      Next
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>
        </form>

        {/* Modal Konfirmasi Permohonan */}
        {isOpenKonfirmasiModal && (
          <div className="fixed inset-0 z-[999] bg-black/60 backdrop-blur-sm flex items-center justify-center p-4">
            <div className="bg-white dark:bg-slate-800 w-full max-w-md rounded-md p-6 shadow-2xl space-y-5 border border-slate-200 dark:border-slate-700">
              <h3 className="font-bold text-lg text-slate-800 dark:text-slate-100 border-b border-slate-100 dark:border-slate-700 pb-3">
                Konfirmasi Request Pemindahan
              </h3>
              
              <div className="space-y-3">
                <p className="text-sm text-slate-600 dark:text-slate-300">
                  Apakah Anda yakin ingin mengajukan request pemindahan <strong>{totalPcs} barang</strong> dengan total berat <strong>{totalBerat.toFixed(3)} gr</strong> ke Brankas Pusat?
                </p>
                <p className="text-xs text-amber-600 dark:text-amber-400 font-medium">
                  Pastikan semua barang sudah sesuai sebelum diajukan.
                </p>
              </div>

              <div className="flex items-center justify-end gap-3 pt-4 border-t border-slate-100 dark:border-slate-700">
                <button
                  type="button"
                  onClick={() => setIsOpenKonfirmasiModal(false)}
                  className="px-4 py-2 text-sm font-medium text-slate-600 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-700 rounded-md transition-all"
                >
                  Batal
                </button>
                <button
                  type="button"
                  onClick={() => {
                    setIsOpenKonfirmasiModal(false);
                    setIsOpenSubmitPin(true);
                  }}
                  className="px-4 py-2 text-sm font-bold text-white bg-amber-500 hover:bg-amber-600 rounded-md shadow-lg shadow-amber-500/30 transition-all flex items-center gap-2"
                >
                  <IconSend size={16} />
                  <span>Iya, Lanjutkan</span>
                </button>
              </div>
            </div>
          </div>
        )}

        {/* PIN Verification Modal sebelum submit permohonan */}
        {isOpenSubmitPin && (
          <PinBrankas
            title="Verifikasi PIN Request Pemindahan"
            subtitle={`Masukkan 6 digit PIN keamanan untuk mengajukan permohonan pemindahan ${totalPcs} barang ke Brankas Pusat.`}
            maxRetries={3}
            onSuccess={() => {
              setIsOpenSubmitPin(false);
              handleSubmitPermohonan();
            }}
            onFailure={() => {
              setIsOpenSubmitPin(false);
            }}
            onCancel={() => {
              setIsOpenSubmitPin(false);
            }}
          />
        )}

        {/* Modal Hapus Bulk Item Sementara */}
        {isOpenBulkDeleteModal && selectedItemIds.length > 0 && (
          <div className="fixed inset-0 z-[999] bg-black/60 backdrop-blur-sm flex items-center justify-center p-4">
            <div className="bg-white dark:bg-slate-800 w-full max-w-md rounded-md p-6 shadow-2xl space-y-4 border border-slate-200 dark:border-slate-700">
              <div className="flex items-center justify-between border-b border-slate-100 dark:border-slate-700 pb-3">
                <h3 className="font-bold text-sm text-slate-800 dark:text-slate-100 flex items-center gap-2">
                  <IconTrash className="text-rose-500" size={18} />
                  <span>Hapus {selectedItemIds.length} Barang Salah Input</span>
                </h3>
                <button onClick={() => setIsOpenBulkDeleteModal(false)} className="text-slate-400 hover:text-slate-600">
                  <IconX size={18} />
                </button>
              </div>

              <div className="bg-rose-50 dark:bg-rose-900/20 p-3 rounded-md border border-rose-200 dark:border-rose-700/50 text-xs space-y-1">
                <p className="font-semibold text-rose-700 dark:text-rose-400">Peringatan!</p>
                <p className="text-rose-600/80 dark:text-rose-400/80">Barang yang dihapus akan tercatat pada Histori Penghapusan sebagai salah input (brankas pusat).</p>
              </div>

              {/* List Barang yang akan dihapus */}
              <div className="max-h-40 overflow-y-auto border border-slate-200 dark:border-slate-700 rounded-md bg-slate-50 dark:bg-slate-900/50">
                <table className="w-full text-xs text-left text-slate-700 dark:text-slate-300">
                  <thead className="bg-gradient-to-r from-amber-50 to-amber-100/70 dark:from-amber-950/40 dark:to-amber-900/30 text-amber-800 dark:text-amber-300 border-b border-amber-200/70 dark:border-amber-800/40 sticky top-0">
                    <tr>
                      <th className="py-2 px-3 font-semibold">Kode Item</th>
                      <th className="py-2 px-3 font-semibold">Jenis</th>
                      <th className="py-2 px-3 font-semibold text-right">Berat</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-slate-200 dark:divide-slate-700">
                    {selectedItemsList.map((i) => (
                      <tr key={i.id}>
                        <td className="py-1.5 px-3 font-mono font-medium">{i.kode_item}</td>
                        <td className="py-1.5 px-3">{i.jenis_kategori?.nama_jenis || '-'}</td>
                        <td className="py-1.5 px-3 text-right">{parseFloat(i.berat || 0).toFixed(3)} gr</td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot className="bg-slate-100 dark:bg-slate-800 font-bold sticky bottom-0 border-t border-slate-200 dark:border-slate-700">
                    <tr>
                      <td colSpan="2" className="py-2 px-3 text-right text-slate-600 dark:text-slate-300">Total Berat:</td>
                      <td className="py-2 px-3 text-right text-rose-600 dark:text-rose-400">{totalBerat.toFixed(3)} gr</td>
                    </tr>
                  </tfoot>
                </table>
              </div>

              <form onSubmit={handleSubmitBulkDelete} className="space-y-4">
                <div className="space-y-1.5">
                  <label className="text-xs font-semibold text-slate-700 dark:text-slate-300">
                    Alasan / Keterangan <span className="text-rose-500">*</span>
                  </label>
                  <textarea
                    className="w-full px-3 py-2 border border-slate-300 dark:border-slate-600 rounded-md bg-slate-50 dark:bg-slate-900 text-sm focus:ring-2 focus:ring-amber-500 outline-none"
                    rows="3"
                    placeholder="Contoh: Salah input berat / batal pindah..."
                    value={alasanPenghapusan}
                    onChange={(e) => setAlasanPenghapusan(e.target.value)}
                    required
                  ></textarea>
                </div>

                <div className="flex justify-end gap-2 pt-2 border-t border-slate-100 dark:border-slate-700">
                  <button
                    type="button"
                    onClick={() => setIsOpenBulkDeleteModal(false)}
                    className="px-4 py-2 text-xs font-semibold text-slate-600 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-700 rounded-md transition-all"
                  >
                    Batal
                  </button>
                  <button
                    type="submit"
                    disabled={isDeleting}
                    className="px-4 py-2 text-xs font-bold text-white bg-rose-500 hover:bg-rose-600 disabled:opacity-50 disabled:cursor-not-allowed rounded-md shadow-sm transition-all flex items-center gap-2"
                  >
                    {isDeleting ? <IconLoader2 size={16} className="animate-spin" /> : <IconTrash size={16} />}
                    <span>{isDeleting ? 'Menghapus...' : 'Ya, Hapus Terpilih'}</span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}

        {/* Modal Hapus Item Sementara */}
        {isOpenDeleteModal && itemToDelete && (
          <div className="fixed inset-0 z-[999] bg-black/60 backdrop-blur-sm flex items-center justify-center p-4">
            <div className="bg-white dark:bg-slate-800 w-full max-w-md rounded-md p-6 shadow-2xl space-y-4 border border-slate-200 dark:border-slate-700">
              <div className="flex items-center justify-between border-b border-slate-100 dark:border-slate-700 pb-3">
                <h3 className="font-bold text-sm text-slate-800 dark:text-slate-100 flex items-center gap-2">
                  <IconTrash className="text-rose-500" size={18} />
                  <span>Hapus Salah Input Barang</span>
                </h3>
                <button onClick={() => setIsOpenDeleteModal(false)} className="text-slate-400 hover:text-slate-600">
                  <IconX size={18} />
                </button>
              </div>

              <div className="bg-rose-50 dark:bg-rose-900/20 p-3 rounded-md border border-rose-200 dark:border-rose-700/50 text-xs space-y-1">
                <p><strong>Kode Item:</strong> <span className="font-mono font-bold text-rose-800 dark:text-rose-300">{itemToDelete.kode_item}</span></p>
                <p><strong>Jenis:</strong> {itemToDelete.jenis_kategori?.nama_jenis}</p>
                <p><strong>Berat / Karat:</strong> {itemToDelete.berat}g ({itemToDelete.karat} K)</p>
              </div>

              <form onSubmit={handleSubmitDeleteItem} className="space-y-4">
                <div>
                  <label className="block text-xs font-bold text-slate-600 dark:text-slate-300 mb-1.5">
                    Alasan Penghapusan <span className="text-rose-500">* (Wajib dicatat di histori)</span>
                  </label>
                  <textarea
                    rows={3}
                    placeholder="Jelaskan alasan kesalahan input..."
                    value={alasanPenghapusan}
                    onChange={(e) => setAlasanPenghapusan(e.target.value)}
                    required
                    className="w-full p-2.5 text-xs border border-slate-300 dark:border-slate-600 rounded-md bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-100 outline-none focus:ring-2 focus:ring-rose-500"
                  />
                </div>

                <div className="flex justify-end gap-2 pt-2 border-t border-slate-100 dark:border-slate-700">
                  <button
                    type="button"
                    onClick={() => setIsOpenDeleteModal(false)}
                    className="px-4 py-2 text-xs font-semibold text-slate-600 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-700 rounded-md transition-all"
                  >
                    Batal
                  </button>
                  <button
                    type="submit"
                    disabled={isDeleting}
                    className="px-4 py-2 text-xs font-bold bg-rose-600 hover:bg-rose-700 text-white rounded-md shadow-lg shadow-rose-600/20 transition-all"
                  >
                    {isDeleting ? 'Menghapus...' : 'Hapus & Catat Histori'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
        {/* Modal Cari Jenis Kategori */}
        {isOpenJenisKategoriModal && (
          <div className="fixed inset-0 z-[999] bg-black/60 backdrop-blur-sm flex items-center justify-center p-4">
            <div className="bg-white dark:bg-slate-800 w-full max-w-md rounded-md p-6 shadow-2xl space-y-4 border border-slate-200 dark:border-slate-700">
              <div className="flex items-center justify-between border-b border-slate-100 dark:border-slate-700 pb-3">
                <h3 className="font-bold text-sm text-slate-800 dark:text-slate-100">
                  Pilih Jenis Kategori
                </h3>
                <button type="button" onClick={() => { setIsOpenJenisKategoriModal(false); setSearchJenisKategori(''); }} className="text-slate-400 hover:text-slate-600">
                  <IconX size={18} />
                </button>
              </div>

              <div className="relative">
                <IconSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={16} />
                <input
                  type="text"
                  placeholder="Cari jenis kategori..."
                  value={searchJenisKategori}
                  onChange={(e) => setSearchJenisKategori(e.target.value)}
                  className="w-full pl-9 pr-3 py-2 text-sm border border-slate-200 dark:border-slate-700 rounded-md bg-slate-50 dark:bg-slate-900/50 outline-none focus:border-amber-500 focus:ring-1 focus:ring-amber-500 text-slate-700 dark:text-slate-200"
                />
              </div>

              <div className="max-h-60 overflow-y-auto space-y-1 pr-1">
                {(() => {
                  const jenisList = kategoriList.find(kt => kt.id === parseInt(selectedKategori))?.jenis_kategori || [];
                  const filtered = jenisList.filter(j => j.nama_jenis.toLowerCase().includes(searchJenisKategori.toLowerCase()));
                  
                  if (filtered.length === 0) {
                    return <div className="text-center text-xs text-slate-500 py-4">Tidak ada jenis kategori ditemukan</div>;
                  }

                  return (
                    <>
                      <button
                        type="button"
                        onClick={() => {
                          setSelectedJenisKategori('');
                          setIsOpenJenisKategoriModal(false);
                          setSearchJenisKategori('');
                          setCurrentPage(1);
                        }}
                        className={`w-full text-left px-3 py-2 text-sm rounded-md transition-colors ${
                          selectedJenisKategori === '' ? 'bg-amber-50 dark:bg-amber-900/20 text-amber-600 font-bold' : 'hover:bg-slate-50 dark:hover:bg-slate-700 text-slate-700 dark:text-slate-200'
                        }`}
                      >
                        Semua Jenis
                      </button>
                      {filtered.map(j => (
                        <button
                          key={j.id}
                          type="button"
                          onClick={() => {
                            setSelectedJenisKategori(j.id.toString());
                            setIsOpenJenisKategoriModal(false);
                            setSearchJenisKategori('');
                            setCurrentPage(1);
                          }}
                          className={`w-full text-left px-3 py-2 text-sm rounded-md transition-colors ${
                            selectedJenisKategori === j.id.toString() ? 'bg-amber-50 dark:bg-amber-900/20 text-amber-600 font-bold' : 'hover:bg-slate-50 dark:hover:bg-slate-700 text-slate-700 dark:text-slate-200'
                          }`}
                        >
                          {j.nama_jenis}
                        </button>
                      ))}
                    </>
                  );
                })()}
              </div>
            </div>
          </div>
        )}

      </div>
      <DetailItem
        closeModalDetail={closeModalDetail}
        openDetail={openDetail}
        detailItem={detailItem}
      />
    </Layouts>
  );
};


